// extracted by mini-css-extract-plugin
module.exports = {"bottom":"QQSection_bottom__2L7J0","separator":"QQSection_separator__18xW-"};